export const ConvertToBenefitTable = (tableData) => {
  const tableColumns = ["#", "Country", "Type", "Benefit", "Value"];

  const columns = tableColumns?.map(
    (item, index) => `<th key=${index}>${item}</th>`
  );

  const data = tableData?.map(
    (item, index) =>
      `<tr key=${index}><td> <div className="d-flex align-items-center"> ${
        index + 1
      }. </div></td><td> <div className="d-flex align-items-center"> ${
        item?.country
      } </div></td><td> <div className="d-flex align-items-center"> ${
        item?.type
      } </div></td><td> <div className="d-flex align-items-center"> ${
        item?.benefit
      } </div></td><td> <div className="d-flex align-items-center"> ${
        item?.value
      } </div></td> </tr>`
  );

  return `<div className="table-responsive my-2"><table border="1" width="100%"><thead><tr>${columns.join(
    ""
  )}</tr></thead><tbody>${data.join("")}</tbody></table></div>`;
};
